// extracted by mini-css-extract-plugin
module.exports = {"dignity":"a10a3f92e9--dignity--Kvl0U","dignity_item":"a10a3f92e9--dignity_item--VbHwy"};